export default [
    {
        code: 'ui.index',
        name: '工作台',
        icon: 'dashboard',
        role: 'auth',
        path: 'index',
        comp: 'index/Index.vue'
    },
    {
        code: 'ums',
        name: '用户管理',
        icon: 'user',
        role: 'PlatAdmin,UnitAdmin',
        subs: [
            {
                code: 'ums.sysemp',
                name: '员工信息',
                icon: 'smile',
                role: 'PlatAdmin',
                path: 'ums/sys/emp',
                comp: 'ums/sys/emp/SysEmp.vue'
            },
            {
                code: 'ums.unitinfo',
                name: '机构信息',
                icon: 'bank',
                role: 'PlatAdmin',
                path: 'ums/unit/info',
                comp: 'ums/unit/info/UnitInfo.vue'
            },
            {
                code: 'ums.syscta',
                name: '心理师信息',
                icon: 'heart',
                role: 'PlatAdmin1',
                path: 'ums/sys/cta',
                comp: 'ums/sys/cta/SysCta.vue'
            },
            {
                code: 'ums.sysmem',
                name: '会员信息',
                icon: 'meh',
                role: 'PlatAdmin',
                path: 'ums/sys/mem',
                comp: 'ums/sys/mem/SysMem.vue'
            },
            {
                code: 'ums.unitemp',
                name: '员工信息',
                icon: 'smile',
                role: 'UnitAdmin',
                path: 'ums/unit/emp',
                comp: 'ums/unit/emp/UnitEmp.vue'
            }
        ]
    },
    {
        code: 'unit',
        name: '机构管理',
        icon: 'bank',
        role: 'UnitAdmin1',
        subs: [
            {
                code: 'unit.cta',
                name: '签约心理师',
                icon: 'heart',
                role: 'UnitAdmin',
                path: 'unit/cta',
                comp: 'unit/cta/UnitCta.vue'
            },
            {
                code: 'unit.team',
                name: '心理群组织',
                icon: 'team',
                role: 'UnitAdmin',
                path: 'unit/team',
                comp: 'unit/team/UnitTeam.vue'
            },
            {
                code: 'unit.items',
                name: '服务项目',
                icon: 'ordered-list',
                role: 'UnitAdmin',
                path: 'unit/items',
                comp: 'unit/items/UnitItems.vue'
            },
            {
                code: 'unit.info',
                name: '机构信息',
                icon: 'profile',
                role: 'UnitAdmin',
                path: 'unit/info',
                comp: 'unit/info/UnitInfo.vue'
            },
            {
                code: 'unit.track',
                name: '传播足迹',
                icon: 'gateway',
                role: 'UnitAdmin',
                path: 'unit/track',
                comp: 'unit/track/UnitTrack.vue'
            }
        ]
    },
    {
        code: 'crs',
        name: '云信网',
        icon: 'credit-card',
        role: 'PlatAdmin1,UnitAdmin1',
        subs: [
            {
                code: 'crs.certtmpl',
                name: '资质模板',
                icon: 'project',
                role: 'PlatAdmin,UnitAdmin',
                path: 'crs/cert/tmpl',
                comp: 'crs/cert/tmpl/CertTmpl.vue'
            },
            {
                code: 'crs.platcert',
                name: '资质信息',
                icon: 'audit',
                role: 'PlatAdmin',
                path: 'crs/plat/cert',
                comp: 'crs/plat/cert/PlatCert.vue'
            },
            {
                code: 'crs.unitcert',
                name: '资质证书',
                icon: 'file-done',
                role: 'UnitAdmin',
                path: 'crs/unit/cert',
                comp: 'crs/unit/cert/UnitCert.vue'
            },
            {
                code: 'crs.unitcourse',
                name: '课程信息',
                icon: 'book',
                role: 'PlatAdmin,UnitAdmin',
                path: 'crs/unit/course',
                comp: 'crs/unit/course/UnitCourse.vue'
            },
            {
                code: 'crs.unitclasses',
                name: '课程期次',
                icon: 'cluster',
                role: 'UnitAdmin',
                path: 'crs/unit/classes',
                comp: 'crs/unit/classes/UnitClasses.vue'
            }
        ]
    },
    {
        code: 'cts',
        name: '云测评',
        icon: 'radar-chart',
        role: 'PlatAdmin,UnitAdmin,UnitEmp',
        subs: [
            {
                code: 'cts.config',
                name: '测评配置',
                icon: 'setting',
                role: 'PlatAdmin',
                path: 'cts/ate/config',
                comp: 'cts/ate/config/AteConfig.vue'
            },
            {
                code: 'cts.platdevice',
                name: '测评设备',
                icon: 'tablet',
                role: 'PlatAdmin',
                path: 'cts/ate/device/plat',
                comp: 'cts/ate/device/AtePlatDevice.vue'
            },
            {
                code: 'cts.unitdevice',
                name: '我的设备',
                icon: 'tablet',
                role: 'UnitAdmin',
                path: 'cts/ate/device/unit',
                comp: 'cts/ate/device/AteUnitDevice.vue'
            },
            {
                code: 'cts.unitorg',
                name: '用户分组',
                icon: 'usergroup-add',
                role: 'UnitAdmin,UnitEmp',
                path: 'cts/ate/torg',
                comp: 'cts/ate/torg/AteUnitOrg.vue'
            },
            {
                code: 'cts.plattester',
                name: '测评用户',
                icon: 'idcard',
                role: 'PlatAdmin',
                path: 'cts/ate/tester/plat',
                comp: 'cts/ate/tester/AtePlatTester.vue'
            },
            {
                code: 'cts.tcode',
                name: '测评密码',
                icon: 'number',
                role: 'UnitAdmin',
                path: 'cts/ate/tcode',
                comp: 'cts/ate/tcode/AteTestingCode.vue'
            },
            {
                code: 'cts.unittester',
                name: '测评用户',
                icon: 'idcard',
                role: 'UnitAdmin,UnitEmp',
                path: 'cts/ate/tester/unit',
                comp: 'cts/ate/tester/AteUnitTester.vue'
            },
            {
                code: 'cts.plattesting',
                name: '测评信息',
                icon: 'profile',
                role: 'PlatAdmin',
                path: 'cts/ate/exam/plat',
                comp: 'cts/ate/exam/AtePlatTestingExam.vue'
            },
            {
                code: 'cts.unittesting',
                name: '测评信息',
                icon: 'profile',
                role: 'UnitAdmin,UnitEmp',
                path: 'cts/ate/exam/unit',
                comp: 'cts/ate/exam/AteUnitTestingExam.vue'
            },
            {
                code: 'cts.platexamstat',
                name: '测评统计',
                icon: 'stock',
                role: 'PlatAdmin',
                path: 'cts/ate/exam/platstat',
                comp: 'cts/ate/exam/AtePlatTestingExamStat.vue'
            },
            {
                code: 'cts.unitexamstat',
                name: '测评统计',
                icon: 'stock',
                role: 'UnitAdmin,UnitEmp',
                path: 'cts/ate/exam/unitstat',
                comp: 'cts/ate/exam/AteUnitTestingExamStat.vue'
            },
            {
                code: 'cts.platexer',
                name: '训练信息',
                icon: 'dribbble-square',
                role: 'PlatAdmin',
                path: 'cts/ate/exer/plat',
                comp: 'cts/ate/exer/AtePlatTestingExer.vue'
            },
            {
                code: 'cts.unitexer',
                name: '训练信息',
                icon: 'dribbble-square',
                role: 'UnitAdmin,UnitEmp',
                path: 'cts/ate/exer/unit',
                comp: 'cts/ate/exer/AteUnitTestingExer.vue'
            },
            {
                code: 'cts.platrace',
                name: '比赛信息',
                icon: 'reddit',
                role: 'PlatAdmin',
                path: 'cts/ate/race/plat',
                comp: 'cts/ate/race/AtePlatRace.vue'
            },
            {
                code: 'cts.unitrace',
                name: '比赛信息',
                icon: 'reddit',
                role: 'UnitAdmin',
                path: 'cts/ate/race/unit',
                comp: 'cts/ate/race/AteUnitRace.vue'
            }
        ]
    }
]
